<!--
 * @Description: 终端结算
 * @Date: 2019-09-02 09:48:51
 -->

<template>
  <div class="table-box">
    <!--查询-->
    <div class="search-box" v-if="!hideSearch">
      <div class="search-left">
        <div>
          <span>项目参与人:</span>
          <el-input
            class="search-input"
            placeholder="项目参与人"
            v-model="searchQuery.fullName"
            clearable
          ></el-input>
        </div>
        <div>
          <span>供应商:</span>
          <el-input
            class="search-input"
            placeholder="供应商"
            v-model="searchQuery.supplieName"
            clearable
          ></el-input>
        </div>
        <!-- <div>
          <span>到账状态:</span>
          <el-select
            clearable
            v-model="searchQuery.title"
            placeholder="到账状态"
          >
            <el-option
              label="未到账"
              :value="1"
            ></el-option>
            <el-option
              label="已到账"
              :value="2"
            ></el-option>
          </el-select>
        </div>-->
        <div>
          <el-button type="primary" @click="searchEvent">搜索</el-button>
          <template
            v-if="
              $route.query.activeTask == 'finished' &&
                $route.name != 'dingdanFour'
            "
          >
            <el-button type="primary" @click="handleDownAllPDF('all')">
              全部下载
            </el-button>
            <el-button
              type="primary"
              @click="handleDownAllPDF('selected')"
              :disabled="!selectedArr.length"
            >
              批量下载
            </el-button>
          </template>
        </div>
      </div>
      <div class="search-right" style="line-height:40px;">
        终端结算总金额：
        <b style="font-size:20px;">{{ tableResp.totalAmount | moneyFixed }}</b>
      </div>
      <div class="search-right" style="line-height:40px;">
        项目支付金额：（结算总价合计）
        <b style="font-size:20px;">
          {{ tableResp.jiesuanTotalAll | moneyFixed }}
        </b>
      </div>
    </div>
    <!--列表-->
    <div class>
      <el-table
        border
        style="width: 100%"
        row-key="orderId"
        ref="payTable"
        :stripe="true"
        :highlight-current-row="false"
        :data="tableData"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selectable"
          reserve-selection
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="fullName"
          label="项目参与人姓名"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userPhone"
          label="手机号"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="收款账号"
          width="140"
        >
          <template slot-scope="{ row }">
            <span v-if="row.collectMoneyType === 2">
              {{ row.zbBankCardNumber }}
            </span>
            <span v-else-if="row.bankNo">{{ row.bankNo }}</span>
            <span style="color:grey" v-else>完成支付后展示</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="收款类型"
        >
          <template slot-scope="scope">
            {{ scope.row.collectMoneyType | transCollectMoneyType }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="类型"
        >
          <template slot-scope="scope">
            {{ scope.row.type | transType }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="任务月度"
          prop="taskDt"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="supplieName"
          label="供应商"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="finishSum"
          label="实际完成任务量"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectNo"
          label="终端结算单价"
          v-if="projectType !== 19"
        >
          <template slot-scope="scope">
            {{ scope.row.taskPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectNo"
          label="终端结算金额"
        >
          <template slot-scope="scope">
            {{ (scope.row.taskPrice * scope.row.finishSum) | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="type != 1"
          :show-overflow-tooltip="true"
          align="center"
          prop="projectNo"
          label="到账状态"
        ></el-table-column>
        <el-table-column
          label="服务费率"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.supplierRate | transScale }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="jiesuanTotal"
          label="结算总价"
        >
          <template slot-scope="{ row }">
            {{ row.jiesuanTotal | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="goContractInfo(scope.row)"
            >
              查看任务
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// import datePicker from "@/Mixin/datePicker";
import { projectPayPeopleDetail, projectV2 } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import { mapActions } from 'vuex';
import receiptDownload from './receiptDownload.js';

export default {
  inject: {
    itemData: {
      default: {
        data: {}
      }
    }
  },
  mixins: [pageInation, makeSure],
  data() {
    return {
      ruleForm: {
        taskDate: ''
      }, // 用户信息
      getList: projectPayPeopleDetail, // 获取列表的AJAX
      searchQuery: {
        csoOrderId: this.itemData.data.id
      },
      projectType: '',
      selectedArr: [] // 选择集合
    };
  },
  props: {
    type: {
      default: 1
    },
    hideSearch: {
      type: Boolean,
      default: false
    },
    customDefaultQuery: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {},
  filters: {
    transType(v) {
      let s = {
        1: '助手联盟',
        2: '医生联盟'
      };
      return s[v];
    }
  },
  computed: {},
  methods: {
    ...mapActions(['syncProjectInfo']),
    // 搜索时清空之前选项
    handleSearch() {
      this.$refs.payTable.clearSelection();
      this.searchEvent();
    },
    // 支付成功的可以被选中
    selectable({ payStatus }) {
      return payStatus === 2;
    },
    handleSelectionChange(v) {
      this.selectedArr = v;
    },
    handleDownAllPDF(type) {
      receiptDownload.call(this, {
        row: this.itemData.data,
        query: this.searchQuery,
        selectedType: type,
        selectedArr: this.selectedArr
      });
    },
    async goContractInfo(row) {
      row.id = row.projectId;
      row.projectStructureType =
        this.itemData.data.projectStructureType ||
        this.customDefaultQuery.projectStructureType;
      let serviceSubitem = '';
      if (row.projectType == 20) {
        const {
          data: { data }
        } = await projectV2.getServiceSubitemByProjectId(row);
        serviceSubitem = (data || {}).serviceSubitem;
      }
      this.syncProjectInfo({
        ...row,
        serviceSubitem
      }).then(() => {
        const routeDate = this.$router.resolve({
          name: 'record',
          query: { id: row.id, fullName: row.fullName, phone: row.userPhone }
        });
        window.open(routeDate.href, '_blank');
      });
      // this.$router.push({
      //   name: 'contractList',
      //   query: {
      //     projectId: `1_2_${row.id}`,
      //     projectName: row.projectName
      //   }
      // });
    },
    preDealTableData(data) {
      this.projectType = data.projectType;
    }
  },
  created() {
    if ('use' in this.customDefaultQuery) {
      delete this.customDefaultQuery.use;
      this.searchQuery = Object.assign(
        {},
        this.searchQuery,
        this.customDefaultQuery
      );
    }
  }
};
</script>
